import { render, staticRenderFns } from "./PersonAddFormWrapper.vue?vue&type=template&id=da3446cc&scoped=true&"
import script from "./PersonAddFormWrapper.vue?vue&type=script&lang=js&"
export * from "./PersonAddFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PersonAddFormWrapper.vue?vue&type=style&index=0&id=da3446cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3446cc",
  null
  
)

export default component.exports